import type { TOC } from '@ember/component/template-only';

import SkeletonScreenComponent from 'webapp/components/skeleton-screen';

interface Args {
	title?: string;
	subtitle?: string;
}

const MetricDetailsChartEmptyComponent: TOC<{ Args: Args }> = <template>
	<div class="metric-details__chart-empty">
		<div class="metric-details__chart-empty-text">
			<span class="metric-details__chart-empty-title">
				{{if @title @title "No data to display"}}
			</span>
			<span class="metric-details__chart-empty-subtitle">
				{{if
					@subtitle
					@subtitle
					"Please try a different date range or remove some filters."
				}}
			</span>
		</div>
		<SkeletonScreenComponent @type="graph" />
	</div>
</template>;

export default MetricDetailsChartEmptyComponent;
